// ** React Imports
import { lazy } from 'react';

const CartsRoutes = [
  {
    path: 'carts',
    component: lazy(() => import('views/carts')),
  },
  {
    path: 'cart/details/:id',
    component: lazy(() => import('views/carts/cart-details')),
  },
];

export default CartsRoutes;
